import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { IBaseSearchRequest, IFilter } from "src/app/core/models/base";
import { WearingPartCategoryService } from "src/app/devices/services/wearing-part-category.service";

export function WearingPartCategoryValidator(wearingPartCategoryService: WearingPartCategoryService, currentCategoryId: string | null): AsyncValidatorFn {
    return (control: AbstractControl) => {
        const filters: IFilter[] = [
            {
                field: 'name',
                operator: 'eq',
                value: control.value
            }
        ];

        // Only add the id filter if currentCategoryId is not null
        if (currentCategoryId) {
            filters.push({
                field: 'id',
                operator: 'neq',
                value: currentCategoryId
            });
        }

        const request: IBaseSearchRequest = {
            pageNumber: 0,
            pageSize: 999999,
            advancedFilter: {
                logic: "and",
                filters: filters
            }
        };

        return wearingPartCategoryService.getWearingPartCategories(request)
            .pipe(
                map(response => {
                    const wearingPartCategories = response.data;

                    return wearingPartCategories.length !== 0 ? { wearingPartCategoryExists: true } : null;
                })
            );
    }
}
